import React from 'react';

const Enquiry = () => {
  return (
    <div className="font-sans text-gray-800 bg-white">
      

      {/* 2. Why Choose Us Section */}
      <section className="py-16 bg-gray-50 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10">
            Why Choose UCS Prime Real Estate?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-[#173d73] mb-3">Unmatched Earning Potential</h3>
              <p className="text-gray-700">
                Enjoy industry-leading commissions and incentives for top performers.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-[#173d73] mb-3">World-Class Training</h3>
              <p className="text-gray-700">
                Whether you’re new to real estate or a seasoned agent, we provide continuous training to sharpen your skills.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-[#173d73] mb-3">Prestigious Projects</h3>
              <p className="text-gray-700">
                Work with the most prominent developers and market Dubai’s most luxurious properties.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-[#173d73] mb-3">Dynamic Culture</h3>
              <p className="text-gray-700">
                Be part of a high-energy, supportive team where your growth matters.
              </p>
            </div>
          </div>
        </div>
      </section>

    

      

   

    
    </div>
  );
};

export default Enquiry;